import React from "react";
import { FiArrowLeft, FiArrowRight } from "react-icons/fi";
import styled from "styled-components";
import { theme } from "src/styles/theme";
import { Tooltip as ReactTooltip } from "react-tooltip";
const Container = styled.div`
  display: flex;
  align-items: center;
  gap: 24px;
  margin-top: 20px;
  margin-bottom: 40px;
  z-index: 1;
`;

const NavigationButton = styled.button`
  width: 43px;
  height: 43px;
  border-radius: 50%;
  background: #1C1C1C33;

  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  cursor: pointer;
  transition: all 0.2s ease;
  box-shadow: ${theme.shadows.small};
  color: #FFF;

  &:hover {
    background-color: rgba(28, 28, 28, 0.4);
    transform: scale(1.05);
  }
`;

const RespondButton = styled.button`
    //width: 104px;
    height: 43px;
    background-color: ${theme.colors.respondButton};
    color: ${theme.colors.white};
    font-family: ${theme.fonts.primary};
    font-weight: ${theme.fontWeights.semiBold};
    font-size: ${theme.fontSizes.base};
    padding: 12px 20px;
    border-radius: ${theme.borderRadius.pill};
    border: none;
    cursor: pointer;
    transition: all 0.2s ease;
    box-shadow: ${theme.shadows.buttonShadow};

    &:hover {
        transform: translateY(-2px);
        box-shadow: ${theme.shadows.medium};
    }
`;
interface NavigationControllerProps{
  hideResponse?: boolean;
  onNavigate: (number:number) => void;
  onResponse: () => void;
  respondText?:string;
}
const NavigationController: React.FC<NavigationControllerProps>=({hideResponse, onNavigate, onResponse,respondText="Respond"})=>{
    return (
        <Container>
            <NavigationButton onClick={()=>onNavigate(-1)}><FiArrowLeft size={30} /></NavigationButton>
            {!hideResponse && <RespondButton  data-tooltip-id={`question-respond`} onClick={onResponse}> {respondText} </RespondButton>}
            <NavigationButton onClick={()=>onNavigate(1)}><FiArrowRight size={30} /></NavigationButton>
            <ReactTooltip
                    id={`question-respond`}
                    style={{width:"250px",zIndex:"9999999999999",backgroundColor: "rgba(255, 255, 255,1)", color: "#222",borderRadius:10 }}
                    place="top"
                    content={"Press to skip to response"}
                  />
        </Container>
    )
}

export default NavigationController;